module.exports = __webpack_public_path__ + "362b00db05faa24fb43c697b6c3ef2ae.jpg";